const UGI_PROJECTS = new Set(["UGI Video 01", "UGI Video 02"]);

export function animatorDoctorName(doctorName, projectName) {
  if (!UGI_PROJECTS.has(projectName) || typeof doctorName !== "string") return doctorName;

  const normalized = doctorName.toLowerCase().replace(/^dr\.?\s*/, "").trim().replace(/\s+/g, " ");
  // Animator's UGI project uses this abbreviated key for Dr. Hanna George.
  return normalized === "hanna george" || normalized === "hanna" ? "Dr. Hanna" : doctorName;
}
